import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'

/**
 * Import
 * - Components
 */
import Renewals from '../../../components/pages/Renewals/Renewals'

/**
 * Import
 * - Actions
 */
import { fecthRenewalsList, fecthLapseRenewal, fecthRenewAsIs , fecthRenewPolicy } from '../../../actions'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        renewals: state.renewals.renewals,
        renewAsIs: state.renewals.renewAsIs,
    }
}

export default connect(mapStateToProps, {
    fecthRenewalsList,
    fecthLapseRenewal,
    fecthRenewAsIs,
    fecthRenewPolicy,
})(Renewals)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Renewals/Renewals.tsx